const PROJECTS_SAVE_RESULT = {
  PENDING_COMMITMENTS: "pending_commitments",
  UNPAID_INVOICES: "unpaid_invoices"
} as const

type ProjectsSaveResultType =
  (typeof PROJECTS_SAVE_RESULT)[keyof typeof PROJECTS_SAVE_RESULT]

export { PROJECTS_SAVE_RESULT }
export type { ProjectsSaveResultType }
